import { HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { SaveForAllDialogComponent } from '../../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { Material } from '../material';
import { MaterialHistorieDialogComponent } from '../material-historie-dialog/material-historie-dialog.component';
import { MaterialPrice } from './material-price';
import { MaterialPricesService } from './material-prices.service';

@Component({
    selector: 'kiene-material-sales-prices',
    templateUrl: './material-prices.component.html',
    styleUrls: ['./material-prices.component.scss'],
})
export class MaterialPricesComponent implements OnInit, OnChanges {
    @Input('material') material: Material;
    @Input('vat') vat = 19;
    @Input('ek') einkaufspreis = 0;
    @Input('rabatt') rabatt = 0;

    materialPrices: MaterialPrice[] = [];

    availableMandantenForArticle: Mandant[] = [];

    vkCtrls: UntypedFormControl[] = [];
    isAdmin: boolean;

    constructor(
        private readonly service: MaterialPricesService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        public dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
        private readonly api: KieneTableService,
        private readonly matDialog: MatDialog,
    ) {}

    ngOnInit() {
        if (this.material && this.material.artikel_id && this.localStorageService.currentUserHasPermission(3201)) {
            this.loadMaterialPrices();
            this.loadAvailableMandantenForThisArticle();
        }
        this.isAdmin = this.localStorageService.currentUserIsAdmin();
    }

    ngOnChanges() {
        if (this.material && this.material.artikel_id && this.localStorageService.currentUserHasPermission(3201)) {
            this.loadMaterialPrices();
            this.loadAvailableMandantenForThisArticle();
        }
    }

    loadAvailableMandantenForThisArticle() {
        if (this.localStorageService.currentUserHasPermission(1005)) {
            let params = new HttpParams().set('artikel_id', this.material.artikel_id.toString());
            this.api.get(this.apiBaseUrl + 'artikel/read_mandanten.php', params).subscribe(
                response => {
                    if (response) {
                        this.availableMandantenForArticle = response.records;
                    }
                },
                error => {
                    this.messageService.errorMessage('Mandanten konnten nicht geladen werden!', error);
                },
            );
        }
    }

    loadMaterialPrices() {
        this.service.loadMaterialPrices(this.material.artikel_id).subscribe(result => {
            this.materialPrices = result.records;
            this.materialPrices.sort((m1, m2) => m1.verkaufspreis_id - m2.verkaufspreis_id);
            this.vkCtrls = [];
            for (let mp of this.materialPrices) {
                const index = mp.verkaufspreis_id + '_' + mp.artikel_id;
                this.vkCtrls[index] = new UntypedFormControl(mp.einzelpreis);
            }
        });
    }

    savePrices() {
        for (let mp of this.materialPrices) {
            mp.einzelpreis = this.vkCtrls[mp.verkaufspreis_id + '_' + mp.artikel_id].value;
        }

        const prices = { preise: this.materialPrices, mandanten_ids: [] };

        if (this.availableMandantenForArticle.length > 1 && this.localStorageService.currentUserHasPermission(1005)) {
            let dialogRef = this.dialog.open(SaveForAllDialogComponent, {
                data: { availableMandanten: this.availableMandantenForArticle },
            });

            dialogRef.afterClosed().subscribe(result => {
                let selectedMandantenIds: number[] = [];
                if (result) {
                    selectedMandantenIds = result;
                    prices.mandanten_ids = selectedMandantenIds;

                    this.service.saveMaterialPrices(prices).subscribe(
                        () => {
                            this.loadMaterialPrices();
                            this.messageService.infoMessage('Die Verkaufspreise wurden gespeichert');
                        },
                        error => {
                            this.messageService.errorMessage(
                                'Die Verkaufspreise konnten nicht gespeichert werden! ',
                                error,
                            );
                        },
                    );
                }
            });
        } else {
            this.service.saveMaterialPrices(prices).subscribe(
                () => {
                    this.loadMaterialPrices();
                    this.messageService.infoMessage('Die Verkaufspreise wurden gespeichert');
                },
                error => {
                    this.messageService.errorMessage('Die Verkaufspreise konnten nicht gespeichert werden! ', error);
                },
            );
        }
    }

    gibRabattiertenPreis() {
        if (this.einkaufspreis > 0 && this.rabatt >= 0 && this.rabatt < 100) {
            return (this.einkaufspreis * (100 - this.rabatt)) / 100;
        }
        return undefined;
    }

    preiseOk(verkaufspreis: number) {
        if (verkaufspreis === null || verkaufspreis === undefined || verkaufspreis <= 0) {
            return false;
        }
        if (this.gibRabattiertenPreis() === undefined) {
            return false;
        }
        return true;
    }

    gibHandelsspanne(verkaufspreis: number) {
        if (!this.preiseOk(verkaufspreis)) {
            return undefined;
        }
        return ((verkaufspreis - this.gibRabattiertenPreis()) / verkaufspreis) * 100.0;
    }

    gibRohertrag(verkaufspreis: number) {
        if (!this.preiseOk(verkaufspreis)) {
            return undefined;
        }
        return verkaufspreis - this.gibRabattiertenPreis();
    }

    gibKalkulationszuschlag(verkaufspreis: number) {
        if (!this.preiseOk(verkaufspreis)) {
            return undefined;
        }
        let preis = this.gibRabattiertenPreis();
        return ((verkaufspreis - preis) / preis) * 100.0;
    }

    gibBruttoVK(verkaufspreis: number) {
        if (!this.preiseOk(verkaufspreis)) {
            return undefined;
        }
        return verkaufspreis * (1 + this.vat / 100.0);
    }

    openHistorieDialog() {
        this.matDialog.open(MaterialHistorieDialogComponent, { data: this.material, minWidth: '90%' });
    }
}
